import React from "react";
import './Landing.css';
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const Landing = () => {

    const navigate = useNavigate();

    // Function to handle navigation
    const handleRedirect = () => {
     navigate("/contact-us");
   };

  return (
    <div className="vapt-landing-container">
      <div className="vapt-landing-content">
        <div className="vapt-landing-heading">Vulnerability Assessment And Penetration Testing Exercise
        </div>
        <p className="vapt-landing-description">Pinpoint vulnerabilities before they become costly breaches. 
        </p>
        <Button variant="contained" className="vapt-landing-ctaBtn" onClick={handleRedirect}>Connect With Us Today</Button>
      </div>
    </div>
  )
}

export default Landing;